import dimg1 from '../images/destination/1.jpg'
import dimg2 from '../images/destination/2.jpg'
import dimg3 from '../images/destination/3.jpg'
import dimg4 from '../images/destination/6.jpg'
import dimg5 from '../images/destination/7.jpg'
import dimg6 from '../images/destination/8.jpg'

import dSimg1 from '../images/destination-single/img-1.jpg'
import dSimg2 from '../images/destination-single/img-2.jpg'
import dSimg3 from '../images/destination-single/img-3.jpg'
import dSimg4 from '../images/destination-single/img-4.jpg'
import dSimg5 from '../images/destination-single/img-5.jpg'
import dSimg6 from '../images/destination-single/img-6.jpg'



const Destinations = [
    {
        id: '1',
        title:'Luxery Hotel and Resort',
        subTitle:'Vietnam Sea Beach',
        dimg1:dimg1,
        dSimg:dSimg1,
        price:'200',
    },
    {
        id: '2',
        title:'The Paris Grand Palace',
        subTitle:'Paris, France',
        dimg1:dimg2,
        dSimg:dSimg2,
        price:'250',
    },
    {
        id: '3',
        title:'Sea Of Stars Resident',
        subTitle:'Vaadhoo, Maldives',
        dimg1:dimg3,
        dSimg:dSimg3,
        price:'280',
    },
    {
        id: '4',
        title:'Hill View Room',
        subTitle:'Vietnam Sea Beach',
        dimg1:dimg4,
        dSimg:dSimg4,
        price:'300',
    },
    {
        id: '5',
        title:'Sea View Resort',
        subTitle:'Paris, France',
        dimg1:dimg5,
        dSimg:dSimg5,
        price:'180',
    },
    {
        id: '6',
        title:'5 star Hotel and Resort',
        subTitle:'Vaadhoo, Maldives',
        dimg1:dimg6,
        dSimg:dSimg6,
        price:'400',
    },
]
export default Destinations;